import type { ImgHTMLAttributes, ReactElement } from "react";
import { ASSETS } from "@/lib/assets";

/**
 * Logotipo oficial Consórcio Bazilio (arquivos PNG reais, trimados ao conteúdo).
 *
 *  variant: "full" → lockup "CONSÓRCIO BAZILIO" (default) · "mark" → só o símbolo B/casa
 *  tone:    "dark" → versão branca/prata (sobre fundo escuro) [default]
 *           "light" → versão dourada (sobre fundo claro)
 *
 * Dimensione com Tailwind no `className` (ex.: "h-12 w-auto").
 */

type Variant = "full" | "mark";
type Tone = "dark" | "light";

type BazilioLogoProps = Omit<
  ImgHTMLAttributes<HTMLImageElement>,
  "src" | "alt"
> & {
  variant?: Variant;
  tone?: Tone;
  alt?: string;
};

const SRC: Record<Tone, Record<Variant, string>> = {
  light: { full: ASSETS.bazilio.logo, mark: ASSETS.bazilio.markGold },
  dark: { full: ASSETS.bazilio.logoWhite, mark: ASSETS.bazilio.markWhite },
};

export function BazilioLogo({
  variant = "full",
  tone = "dark",
  alt = "Consórcio Bazilio",
  className = "h-10 w-auto",
  loading = "eager",
  decoding = "async",
  draggable = false,
  ...rest
}: BazilioLogoProps): ReactElement {
  return (
    <img
      src={SRC[tone][variant]}
      alt={alt}
      className={className}
      loading={loading}
      decoding={decoding}
      draggable={draggable}
      {...rest}
    />
  );
}
